import {
  CANCEL_PATCH_JOB,
  CANCEL_PATCH_JOB_IS_ERROR,
  CANCEL_PATCH_JOB_IS_PENDING,
  CHANGE_REPORT_EMAIL_IN_BULK,
  CHANGE_REPORT_EMAIL_IN_BULK_IS_ERROR,
  CHANGE_REPORT_EMAIL_IN_BULK_IS_PENDING,
  CREATE_PATCH_JOB,
  CREATE_PATCH_JOB_IS_ERROR,
  CREATE_PATCH_JOB_IS_PENDING,
  EDIT_PATCH_JOB,
  EDIT_PATCH_JOB_IS_ERROR,
  EDIT_PATCH_JOB_IS_PENDING,
  FETCH_FAILED_INSTANCES,
  FETCH_FAILED_INSTANCES_IS_ERROR,
  FETCH_FAILED_INSTANCES_IS_PENDING,
  FETCH_PATCH_JOB_BY_ID,
  FETCH_PATCH_JOB_BY_ID_IS_ERROR,
  FETCH_PATCH_JOB_BY_ID_IS_PENDING,
  FETCH_PATCH_JOB_TYPE,
  FETCH_PATCH_JOB_TYPE_IS_ERROR,
  FETCH_PATCH_JOB_TYPE_IS_PENDING,
  FETCH_PATCHING_STATUS,
  FETCH_PATCHING_STATUS_IS_ERROR,
  FETCH_PATCHING_STATUS_IS_PENDING,
  FETCH_PATCHING_SUMMARY,
  FETCH_PATCHING_SUMMARY_IS_ERROR,
  FETCH_PATCHING_SUMMARY_IS_PENDING,
  FETCH_REPORT_EMAIL,
  FETCH_REPORT_EMAIL_IS_ERROR,
  FETCH_REPORT_EMAIL_IS_PENDING,
  FETCH_REPORT_PROGRESS,
  FETCH_REPORT_PROGRESS_IS_ERROR,
  FETCH_REPORT_PROGRESS_IS_PENDING,
  HOLD_PATCH_JOB,
  HOLD_PATCH_JOB_IS_ERROR,
  HOLD_PATCH_JOB_IS_PENDING,
  PATCH_JOB_PREVIEW,
  PATCH_JOB_PREVIEW_IS_ERROR,
  PATCH_JOB_PREVIEW_IS_PENDING,
  PatchJobActions,
  PatchJobReducerState,
  SORT,
  STOP_PATCH_JOB,
  STOP_PATCH_JOB_IS_ERROR,
  STOP_PATCH_JOB_IS_PENDING,
  UN_HOLD_PATCH_JOB,
  UN_HOLD_PATCH_JOB_IS_ERROR,
  UN_HOLD_PATCH_JOB_IS_PENDING,
} from 'services/GameHosting/PatchJob/types';
import * as apiActionTypes from 'utils/apiActionTypes';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  patchJobSummary: [],
  patchJob: undefined,
  patchJobReportProgress: undefined,
  patchJobFailedInstances: [],
  summaryIsCompleted: false,
  summaryIsPending: false,
  summaryIsError: null,
  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,
  sortBy: 'schedulerStartTime',
  sortDirection: 'ASC',
  params: undefined,
  status: [],
  statusIsCompleted: false,
  statusIsPending: false,
  statusIsError: null,
  preview: [],
  previewIsCompleted: false,
  previewIsPending: false,
  previewIsError: null,
  type: [],
  fetchTypeIsCompleted: false,
  fetchTypeIsPending: false,
  fetchTypeIsError: null,
  email: [],
  fetchEmailIsCompleted: false,
  fetchEmailIsPending: false,
  fetchEmailIsError: null,
  holdIsCompleted: false,
  holdIsPending: false,
  holdIsError: null,
  unPostPoneIsCompleted: false,
  unPostPoneIsPending: false,
  unPostPoneIsError: null,
  fetchReportProgressIsCompleted: false,
  fetchReportProgressIsPending: false,
  fetchReportProgressIsError: null,
  failedIsCompleted: false,
  failedIsPending: false,
  failedIsError: null,
  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,
  editIsCompleted: false,
  editIsPending: false,
  editIsError: null,
  cancelIsCompleted: false,
  cancelIsPending: false,
  cancelIsError: null,
  stopIsCompleted: false,
  stopIsPending: false,
  stopIsError: null,
  changeReportSettingInBulkIsCompleted: false,
  changeReportSettingInBulkIsPending: false,
  changeReportSettingInBulkIsError: null,
} satisfies PatchJobReducerState;

const patchJobReducer = (previousState: PatchJobReducerState | undefined, action: PatchJobActions): PatchJobReducerState => {
  const state: PatchJobReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_PATCH_JOB_BY_ID: {
      const { data } = action;

      return {
        ...state,
        patchJobSummary: state.patchJobSummary.map((item) => {
          if (item.id === data?.id) {
            return {
              ...item,
              ...data,
            };
          }

          return item;
        }),
        patchJob: data ?? state.patchJob,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    }

    case FETCH_PATCH_JOB_BY_ID_IS_PENDING:
      return {
        ...state,
        // stay completed if we are just reloading
        fetchByIdIsCompleted: state.fetchByIdIsCompleted && state.patchJob?.id === action?.id,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_PATCH_JOB_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: action.error,
      };

    case FETCH_REPORT_PROGRESS:
      return {
        ...state,
        patchJobReportProgress: action.data ?? state.patchJobReportProgress,
        fetchReportProgressIsCompleted: true,
        fetchReportProgressIsPending: false,
        fetchReportProgressIsError: null,
      };
    case FETCH_REPORT_PROGRESS_IS_PENDING:
      return {
        ...state,
        fetchReportProgressIsCompleted: state.fetchReportProgressIsCompleted && state.patchJob?.id === action?.id,
        fetchReportProgressIsPending: true,
        fetchReportProgressIsError: null,
      };
    case FETCH_REPORT_PROGRESS_IS_ERROR:
      return {
        ...state,
        fetchReportProgressIsCompleted: true,
        fetchReportProgressIsPending: false,
        fetchReportProgressIsError: action.error,
      };
    case FETCH_FAILED_INSTANCES:
      return {
        ...state,
        patchJobFailedInstances: action.data ?? state.patchJobFailedInstances ?? [],
        failedIsCompleted: true,
        failedIsPending: false,
        failedIsError: null,
      };
    case FETCH_FAILED_INSTANCES_IS_PENDING:
      return {
        ...state,
        failedIsCompleted: state.failedIsCompleted && state.patchJob?.id === action?.id,
        failedIsPending: true,
        failedIsError: null,
      };
    case FETCH_FAILED_INSTANCES_IS_ERROR:
      return {
        ...state,
        failedIsCompleted: true,
        failedIsPending: false,
        failedIsError: action.error,
      };

    case PATCH_JOB_PREVIEW:
      return {
        ...state,
        preview: action.data ?? state.preview ?? [],
        previewIsCompleted: true,
        previewIsPending: false,
        previewIsError: null,
      };
    case PATCH_JOB_PREVIEW_IS_PENDING:
      return {
        ...state,
        previewIsCompleted: false,
        previewIsPending: true,
        previewIsError: null,
      };
    case PATCH_JOB_PREVIEW_IS_ERROR:
      return {
        ...state,
        preview: [],
        previewIsCompleted: true,
        previewIsPending: false,
        previewIsError: action.error,
      };

    case HOLD_PATCH_JOB: {
      const { data } = action;

      return {
        ...state,
        patchJobSummary: state.patchJobSummary.map((item) => {
          if (item.id !== data?.id) {
            return item;
          }

          return {
            ...item,
            status: data.status,
          };
        }),
        patchJob: data ?? state.patchJob,
        holdIsCompleted: true,
        holdIsPending: false,
        holdIsError: null,
      };
    }

    case HOLD_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        holdIsCompleted: false,
        holdIsPending: true,
        holdIsError: null,
      };
    case HOLD_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        holdIsCompleted: true,
        holdIsPending: false,
        holdIsError: action.error,
      };

    case UN_HOLD_PATCH_JOB: {
      const { data } = action;

      return {
        ...state,
        patchJobSummary: state.patchJobSummary.map((item) => {
          if (item.id !== data?.id) {
            return item;
          }

          return {
            ...item,
            status: data.status,
          };
        }),
        patchJob: data ?? state.patchJob,
        unPostPoneIsCompleted: true,
        unPostPoneIsPending: false,
        unPostPoneIsError: null,
      };
    }

    case UN_HOLD_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        unPostPoneIsCompleted: false,
        unPostPoneIsPending: true,
        unPostPoneIsError: null,
      };
    case UN_HOLD_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        unPostPoneIsCompleted: true,
        unPostPoneIsPending: false,
        unPostPoneIsError: action.error,
      };
    case FETCH_PATCHING_SUMMARY:
      return {
        ...state,
        patchJobSummary: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params?.sortSearchValue ?? state.params?.value,
        }),
        summaryIsCompleted: true,
        summaryIsPending: false,
        summaryIsError: null,
      };
    case FETCH_PATCHING_SUMMARY_IS_PENDING:
      return {
        ...state,
        summaryIsCompleted: state.summaryIsCompleted,
        summaryIsPending: true,
        summaryIsError: null,
      };
    case FETCH_PATCHING_SUMMARY_IS_ERROR:
      return {
        ...state,
        summaryIsCompleted: true,
        summaryIsPending: false,
        summaryIsError: action.error,
      };
    case CREATE_PATCH_JOB:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    case CREATE_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,
        createIsError: action.error,
      };

    case EDIT_PATCH_JOB: {
      const update = action.data;

      if (!update) {
        // nothing to change
        return { ...state, editIsCompleted: true, editIsPending: false, editIsError: null };
      }

      return {
        ...state,
        patchJobSummary: state.patchJobSummary.map((item) => {
          if (item.id === update.id) {
            return { ...item, schedulerStartTime: update.schedulerStartTime ?? item.schedulerStartTime, status: update.status };
          }

          return item;
        }),
        patchJob: update,
        editIsCompleted: true,
        editIsPending: false,
        editIsError: null,
      };
    }

    case EDIT_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        editIsCompleted: false,
        editIsPending: true,
        editIsError: null,
      };
    case EDIT_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        editIsCompleted: true,
        editIsPending: false,
        editIsError: action.error,
      };

    case FETCH_PATCHING_STATUS:
      return {
        ...state,
        status: action.data ?? [],
        statusIsCompleted: true,
        statusIsPending: false,
        statusIsError: null,
      };
    case FETCH_PATCHING_STATUS_IS_PENDING:
      return {
        ...state,
        statusIsCompleted: false,
        statusIsPending: true,
        statusIsError: null,
      };
    case FETCH_PATCHING_STATUS_IS_ERROR:
      return {
        ...state,
        statusIsCompleted: true,
        statusIsPending: false,
        statusIsError: action.error,
      };
    case FETCH_PATCH_JOB_TYPE:
      return {
        ...state,
        type: action.data ?? [],
        fetchTypeIsCompleted: true,
        fetchTypeIsPending: false,
        fetchTypeIsError: null,
      };
    case FETCH_PATCH_JOB_TYPE_IS_PENDING:
      return {
        ...state,
        fetchTypeIsCompleted: false,
        fetchTypeIsPending: true,
        fetchTypeIsError: null,
      };
    case FETCH_PATCH_JOB_TYPE_IS_ERROR:
      return {
        ...state,
        fetchTypeIsCompleted: true,
        fetchTypeIsPending: false,
        fetchTypeIsError: action.error,
      };
    case FETCH_REPORT_EMAIL:
      return {
        ...state,
        email: action.data ?? [],
        fetchEmailIsCompleted: true,
        fetchEmailIsPending: false,
        fetchEmailIsError: null,
      };
    case FETCH_REPORT_EMAIL_IS_PENDING:
      return {
        ...state,
        fetchEmailIsCompleted: false,
        fetchEmailIsPending: true,
        fetchEmailIsError: null,
      };
    case FETCH_REPORT_EMAIL_IS_ERROR:
      return {
        ...state,
        fetchEmailIsCompleted: true,
        fetchEmailIsPending: false,
        fetchEmailIsError: action.error,
      };
    case CHANGE_REPORT_EMAIL_IN_BULK:
      return {
        ...state,
        changeReportSettingInBulkIsCompleted: true,
        changeReportSettingInBulkIsPending: false,
        changeReportSettingInBulkIsError: null,
      };
    case CHANGE_REPORT_EMAIL_IN_BULK_IS_PENDING:
      return {
        ...state,
        changeReportSettingInBulkIsCompleted: false,
        changeReportSettingInBulkIsPending: true,
        changeReportSettingInBulkIsError: null,
      };
    case CHANGE_REPORT_EMAIL_IN_BULK_IS_ERROR:
      return {
        ...state,
        changeReportSettingInBulkIsCompleted: true,
        changeReportSettingInBulkIsPending: false,
        changeReportSettingInBulkIsError: action.error,
      };

    case CANCEL_PATCH_JOB:
      return {
        ...state,
        patchJob: action.data,
        cancelIsCompleted: true,
        cancelIsPending: false,
        cancelIsError: null,
      };
    case CANCEL_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: true,
        cancelIsError: null,
      };
    case CANCEL_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: true,
        cancelIsError: action.error,
      };
    case STOP_PATCH_JOB:
      return {
        ...state,
        stopIsCompleted: true,
        stopIsPending: false,
        stopIsError: null,
      };
    case STOP_PATCH_JOB_IS_PENDING:
      return {
        ...state,
        stopIsCompleted: true,
        stopIsPending: true,
        stopIsError: null,
      };
    case STOP_PATCH_JOB_IS_ERROR:
      return {
        ...state,
        stopIsCompleted: true,
        stopIsPending: true,
        stopIsError: action.error,
      };

    case SORT:
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        params: action.params,
        patchJobSummary: sort(state.patchJobSummary, {
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    case apiActionTypes.CLEAN_ERROR:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,
          [action.reducerProperty]:
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };

    case 'RESET_PATCHING_REDUCER':
    case 'RESET_REDUCER':
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default patchJobReducer;
